module.exports = __webpack_public_path__ + "static/assets/c3da9b8e340cd0c14ffa5ebc666abd6b.svg";